module.exports = __webpack_public_path__ + "static/NisargWath-14bf1c0f7a5f1826dda45dff77f9c2ca.jpg";